import React from 'react';
import './Terms.css';
import ResourcesNav from './ResourcesNav';
import Footer from './Footer';

function Terms() {
  React.useEffect(() => {
    document.body.classList.add('terms-page');
    return () => {
      document.body.classList.remove('terms-page');
    };
  }, []);

  return (
    <>
      <ResourcesNav />
      
      <div className="terms-container">
        <div className="terms-content">
          <h1>Terms of Service</h1>
          <p className="terms-updated">Last updated: December 2025</p>
          
          <section className="terms-section">
            <h2>1. Acceptance of Terms</h2>
            <p>
              By requesting an API key and using the LGBT Resources Widget or Map ("Service"), 
              you agree to be bound by these Terms of Service. If you do not agree to these terms, 
              please do not use our Service.
            </p>
          </section>

          <section className="terms-section">
            <h2>2. Description of Service</h2>
            <p>
              The LGBT Resources Widget and Map provide access to a database of LGBT+ community 
              resources powered by the LGBT National Help Center. The Service is provided free 
              of charge for non-commercial, community-focused use.
            </p>
          </section>

          <section className="terms-section">
            <h2>3. Permitted Use</h2>
            <p>You agree to use the Service only for:</p>
            <ul>
              <li>Helping individuals find LGBT+ resources and support services</li>
              <li>Educational and community outreach purposes</li>
              <li>Non-commercial websites and applications</li>
            </ul>
          </section>

          <section className="terms-section">
            <h2>4. Prohibited Use</h2>
            <p>You agree NOT to use the Service for:</p>
            <ul>
              <li>Any discriminatory, harmful, or hateful purposes</li>
              <li>Collecting or harvesting user data without consent</li>
              <li>Misrepresenting the source or nature of the resources</li>
              <li>Any illegal activities or purposes</li>
              <li>Reselling or redistributing the data commercially</li>
              <li>Attempting to reverse engineer or compromise the Service</li>
            </ul>
          </section>

          <section className="terms-section">
            <h2>5. API Key Usage</h2>
            <p>
              Your API key is for your organization's use only. You agree to:
            </p>
            <ul>
              <li>Keep your API key confidential</li>
              <li>Not share your API key with third parties</li>
              <li>Notify us immediately if your key is compromised</li>
              <li>Use only one API key per website/application</li>
            </ul>
          </section>

          <section className="terms-section">
            <h2>6. Youth Safe Mode</h2>
            <p>
              If you select Youth Safe Mode, you acknowledge that this mode filters out 
              adult-oriented venues (bars, clubs, etc.) and agree to implement this 
              appropriately for your audience.
            </p>
          </section>

          <section className="terms-section">
            <h2>7. Data Accuracy</h2>
            <p>
              While we strive to maintain accurate and up-to-date resource information, 
              we cannot guarantee the accuracy, completeness, or availability of all 
              listed resources. Users should verify resource information independently.
            </p>
          </section>

          <section className="terms-section">
            <h2>8. Termination</h2>
            <p>
              We reserve the right to revoke API keys and terminate access to the Service 
              at any time, for any reason, including but not limited to violation of these 
              Terms of Service.
            </p>
          </section>

          <section className="terms-section">
            <h2>9. Disclaimer of Warranties</h2>
            <p>
              The Service is provided "as is" without warranties of any kind, either 
              express or implied. We do not warrant that the Service will be uninterrupted, 
              error-free, or completely secure.
            </p>
          </section>

          <section className="terms-section">
            <h2>10. Limitation of Liability</h2>
            <p>
              To the maximum extent permitted by law, we shall not be liable for any 
              indirect, incidental, special, consequential, or punitive damages arising 
              from your use of the Service.
            </p>
          </section>

          <section className="terms-section">
            <h2>11. Changes to Terms</h2>
            <p>
              We may update these Terms of Service from time to time. Continued use of 
              the Service after changes constitutes acceptance of the new terms.
            </p>
          </section>

          <section className="terms-section">
            <h2>12. Contact</h2>
            <p>
              For questions about these Terms of Service, please contact the LGBT National 
              Help Center at{' '}
              <a href="mailto:help@lgbthotline.org">help@lgbthotline.org</a>
            </p>
          </section>

          <div className="terms-back">
            <button 
              onClick={() => window.close()} 
              className="close-tab-btn"
            >
              Close
            </button>
            <p className="close-hint">This will close the tab and return you to the form</p>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
}

export default Terms;